import React from 'react';
import FAIcon from 'faIcon';

export default class HostTipsTab extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		let iconData = {
			Size: 26,
			Fill: "#999999"
		}

		let congrats = this.props.showCongrats_HostTips ? (
			<div>
				<h3>{this.props.resources['PWS.MyAccount.HostTipsCongratulationsHeading']}</h3>
				<div className="formSectionSubTitle">{this.props.resources['PWS.MyAccount.HostTipsCongratulationsMessage']}</div>
			</div>
		) : null;

		return (
			<div className="active clearfix animate-in">
				{congrats}
				<div className="spacer12"></div>
				<div>{this.props.resources['PWS.MyAccount.HostTipsIntroductionText']}</div>

				<div className="spacer12"></div>
				<div className="spacer12"></div>

				<ol id="tips-tabs-list" style={{listStyle: 'none', listStylePosition: 'outside'}}>
					<li>
						<FAIcon iconData={iconData} name="calendar_check_o" inline={true} styleClass="style02" />&nbsp;
						<span className="formSectionTitle">{this.props.resources['PWS.MyAccount.PartyDetailsTabMyPartyLabel']}</span> - {this.props.resources['PWS.MyAccount.HostTipsMyPartyContent']}
					</li>
					<div className="spacer12"></div>
					<li>
						<FAIcon iconData={iconData} name="envelope_o" inline={true} styleClass="style02" />&nbsp;
						<span className="formSectionTitle">{this.props.resources['PWS.MyAccount.PartyDetailsTabGuestsLabel']}</span> - {this.props.resources['PWS.MyAccount.HostTipsGuestsContent']}
					</li>
					<div className="spacer12"></div>
					<li>
						<FAIcon iconData={iconData} name="shopping_cart" inline={true} styleClass="style02" />&nbsp;
						<span className="formSectionTitle">{this.props.resources['PWS.MyAccount.PartyDetailsTabOrdersLabel']}</span> - {this.props.resources['PWS.MyAccount.HostTipsOrdersContent']}
					</li>
					<div className="spacer12"></div>
					<li>
						<FAIcon iconData={iconData} name="gift" inline={true} styleClass="style02" />&nbsp;
						<span className="formSectionTitle">{this.props.resources['PWS.MyAccount.PartyDetailsTabHostRewardsLabel']}</span> - {this.props.resources['PWS.MyAccount.HostTipsRewardsContent']}
					</li>
					<div className="spacer12"></div>
					<li>
						<FAIcon iconData={iconData} name="lightbulb_o" inline={true} styleClass="style02" />&nbsp;
						<span className="formSectionTitle">{this.props.resources['PWS.MyAccount.PartyDetailsTabHostTipsLabel']}</span> - {this.props.resources['PWS.MyAccount.HostTipsTipsContent']}
					</li>
				</ol>

				<div className="spacer12"></div>
				<div className="spacer12"></div>
				<div className="spacer12"></div>
				<div className="spacer12"></div>
				<div className="simpleHR"></div>
				<div className="formSectionSubTitle">{this.props.resources['PWS.MyAccount.HostTipsCustomContentLabel']}</div>
				<div>{this.props.resources['PWS.MyAccount.HostTipsCustomContent']}</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/Tab_HostTips.js